<template>
    <Tag :text="text" :classes="classes" :small="small" />
</template>

<script>
import Tag from '@/Components/Elements/Tags/Tag.vue'
export default {
    name: 'ModelStyledTag',

    components: {
        Tag,
    },

    props: {
        text: {
            type: String,
            required: true,
        },
        modelClass: {
            type: String,
            required: true,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        classes() {
            return `bg-${this.modelClass}/50 border-${this.modelClass}-accent text-${this.modelClass}-accent`
        },
    },
}
</script>
